var map = {
	"./CompScope_BASE.png": "a9f0",
	"./CompScope_Bright_01.png": "73ea",
	"./CompScope_Bright_02.png": "a3a1",
	"./CompScope_Bright_03.png": "b957",
	"./CompScope_Bright_04.png": "91f5",
	"./CompScope_Bright_05.png": "8d01",
	"./CompScope_Bright_06.png": "8d63",
	"./CompScope_Bright_07.png": "bffb",
	"./CompScope_Bright_08.png": "585a",
	"./CompScope_Bright_09.png": "b91a",
	"./CompScope_Bright_10.png": "7c0e",
	"./CompScope_Mag_1_Focus_0.png": "1595",
	"./CompScope_Mag_1_Focus_1.png": "bd23",
	"./CompScope_Mag_1_Focus_2.png": "4fd1",
	"./CompScope_Mag_2_Focus_0.png": "a882",
	"./CompScope_Mag_2_Focus_1.png": "e846",
	"./CompScope_Mag_2_Focus_2.png": "f976",
	"./CompScope_Mag_3_Focus_0.png": "dd3d",
	"./CompScope_Mag_3_Focus_1.png": "1113",
	"./CompScope_Mag_3_Focus_2.png": "7254",
	"./CompScope_Mag_4_Focus_0.png": "3f63",
	"./CompScope_Mag_4_Focus_1.png": "0656",
	"./CompScope_Mag_4_Focus_2.png": "0b16",
	"./CompScope_Space_00.png": "2fb5",
	"./CompScope_Space_01.png": "8f10",
	"./CompScope_Space_02.png": "e3b2",
	"./CompScope_Space_03.png": "af9a",
	"./CompScope_Space_04.png": "c933",
	"./CompScope_Space_05.png": "3fa7",
	"./CompScope_Space_06.png": "beed",
	"./CompScope_Space_07.png": "e9ce",
	"./CompScope_Space_08.png": "e210",
	"./CompScope_Space_09.png": "1275",
	"./CompScope_Space_10.png": "c1fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b88d";